/* eslint-disable eqeqeq */
/* eslint-disable no-useless-escape */
// ///////////////////////////////////////////////////////////
// tbBrowser: Browser detection functionality
//
// Copyright 2013-2014 CoolGames
// Last Changed: 18-11-2014
// ///////////////////////////////////////////////////////////
var TBBrowser = function (userAgent) {
    "use strict";
    this.userAgent = userAgent;
    if (this.userAgent === undefined) {
        this.userAgent = (navigator !== undefined) ? navigator.userAgent : "";
    }
    this.detect();
};
TBBrowser.prototype.getFirstMatch = function (regex) {
    "use strict";
    var match = this.userAgent.match(regex);
    return (match && match.length > 1 && match[1]) || "";
};
TBBrowser.prototype.detect = function () {
    "use strict";
    var iosdevice = this.getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase(), likeAndroid = /like android/i.test(this.userAgent), android = !likeAndroid && /android/i.test(this.userAgent), versionIdentifier = this.getFirstMatch(/version\/(\d+(\.\d+)?)/i), tablet = /tablet/i.test(this.userAgent), mobile = !tablet && /[^-]mobi/i.test(this.userAgent);
    this.browser = {};
    this.os = {};
    this.features = {};
    // Opera
    if (/opera|opr/i.test(this.userAgent)) {
        this.name = "Opera";
        this.browser.opera = true;
        this.browser.version = versionIdentifier || this.getFirstMatch(/(?:opera|opr)[\s\/](\d+(\.\d+)?)/i);
    }
    // Windows Phone
    else if (/windows phone/i.test(this.userAgent)) {
        this.name = "Windows Phone";
        this.os.windowsphone = true;
        this.browser.msie = true;
        this.browser.version = this.getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i);
    }
    // Internet Explorer
    else if (/msie|trident/i.test(this.userAgent)) {
        this.name = "Internet Explorer";
        this.browser.msie = true;
        this.browser.version = this.getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i);
    }
    // Chrome
    else if (/chrome|crios|crmo/i.test(this.userAgent)) {
        this.name = "Chrome";
        this.browser.chrome = true;
        this.browser.version = this.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i);
    }
    // iOS
    else if (iosdevice) {
        this.name = iosdevice == "iphone" ? "iPhone" : iosdevice == "ipad" ? "iPad" : "iPod";
        if (versionIdentifier) {
            this.browser.version = versionIdentifier;
        }
    }
    // Sailfish
    else if (/sailfish/i.test(this.userAgent)) {
        this.name = "Sailfish";
        this.browser.sailfish = true;
        this.browser.version = this.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i);
    }
    // SeaMonkey
    else if (/seamonkey\//i.test(this.userAgent)) {
        this.name = "SeaMonkey";
        this.browser.seamonkey = true;
        this.browser.version = this.getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i);
    }
    // Firefox
    else if (/firefox|iceweasel/i.test(this.userAgent)) {
        this.name = "Firefox";
        this.browser.firefox = true;
        this.browser.version = this.getFirstMatch(/(?:firefox|iceweasel)[ \/](\d+(\.\d+)?)/i);
        if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(this.userAgent)) {
            this.os.firefoxos = true;
        }
    }
    // Amazon Silk
    else if (/silk/i.test(this.userAgent)) {
        this.name = "Amazon Silk";
        this.browser.silk = true;
        this.browser.version = this.getFirstMatch(/silk\/(\d+(\.\d+)?)/i);
    }
    // Android
    else if (android) {
        this.name = "Android";
        this.browser.stockandroid = true;
        this.browser.version = versionIdentifier;
    }
    // PhantomJS
    else if (/phantom/i.test(this.userAgent)) {
        this.name = "PhantomJS";
        this.browser.phantom = true;
        this.browser.version = this.getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i);
    }
    // BlackBerry
    else if (/blackberry|\bbb\d+/i.test(this.userAgent) || /rim\stablet/i.test(this.userAgent)) {
        this.name = "BlackBerry";
        this.browser.blackberry = true;
        this.browser.version = versionIdentifier || this.getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i);
    }
    // WebOS
    else if (/(web|hpw)os/i.test(this.userAgent)) {
        this.name = "WebOS";
        this.browser.webos = true;
        this.browser.version = versionIdentifier || this.getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i);
        if (/touchpad\//i.test(this.userAgent)) {
            this.features.touchpad = true;
        }
    }
    // Bada
    else if (/bada/i.test(this.userAgent)) {
        this.name = "Bada";
        this.browser.bada = true;
        this.browser.version = this.getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i);
    }
    // Tizen
    else if (/tizen/i.test(this.userAgent)) {
        this.name = "Tizen";
        this.browser.tizen = true;
        this.browser.version = this.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier;
    }
    // Safari
    else if (/safari/i.test(this.userAgent)) {
        this.name = "Safari";
        this.browser.safari = true;
        this.browser.version = versionIdentifier;
    }
    // Unknown!
    else {
        // Do nothing
    }
    // Set webkit or gecko flag for browsers based on these engines
    if (/(apple)?webkit/i.test(this.userAgent)) {
        this.name = this.name || "Webkit";
        this.browser.webkit = true;
        if (!this.browser.version && versionIdentifier) {
            this.browser.version = versionIdentifier;
        }
    }
    else if (!this.opera && /gecko\//i.test(this.userAgent)) {
        this.name = this.name || "Gecko";
        this.browser.gecko = true;
        this.browser.version = this.browser.version || this.getFirstMatch(/gecko\/(\d+(\.\d+)?)/i);
    }
    // Set OS flags for platforms that have multiple browsers
    if (android || this.silk) {
        this.os.android = true;
    }
    else if (iosdevice) {
        this.os.ios = true;
    }
    // OS version extraction
    var osVersion = "";
    if (iosdevice) {
        osVersion = this.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
        osVersion = osVersion.replace(/[_\s]/g, ".");
    }
    else if (android) {
        osVersion = this.getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    }
    else if (this.windowsphone) {
        osVersion = this.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    }
    else if (this.webos) {
        osVersion = this.getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    }
    else if (this.blackberry) {
        osVersion = this.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    }
    else if (this.bada) {
        osVersion = this.getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    }
    else if (this.tizen) {
        osVersion = this.getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
        this.os.version = osVersion;
    }
    // Device type extraction
    var osMajorVersion = osVersion.split(".")[0];
    if (tablet || iosdevice == "ipad" || (android && (osMajorVersion === "3" || (osMajorVersion === "4" && !mobile))) || this.silk) {
        this.features.tablet = true;
    }
    else if (mobile || iosdevice == "iphone" || iosdevice == "ipod" || android || this.blackberry || this.webos || this.bada) {
        this.features.mobile = true;
    }
    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    this.grade = { a: false, c: false, x: false };
    if ((this.msie && this.browser.version >= 10) ||
        (this.chrome && this.browser.version >= 20) ||
        (this.firefox && this.browser.version >= 20.0) ||
        (this.safari && this.browser.version >= 6) ||
        (this.opera && this.browser.version >= 10.0) ||
        (this.ios && this.os.version && this.os.version.split(".")[0] >= 6)) {
        this.grade.a = true;
    }
    else if ((this.msie && this.browser.version < 10) ||
        (this.chrome && this.browser.version < 20) ||
        (this.firefox && this.browser.version < 20.0) ||
        (this.safari && this.browser.version < 6) ||
        (this.opera && this.browser.version < 10.0) ||
        (this.ios && this.os.version && this.os.version.split(".")[0] < 6)) {
        this.grade.c = true;
    }
    else {
        this.grade.x = true;
    }
    try {
        this.browser.versionAsNumber = this.browser.version ? parseFloat(this.browser.version.match(/\d+(\.\d+)?/)[0]) : 0;
    }
    catch (e) {
        this.browser.versionAsNumber = 0;
    }
    try {
        this.os.versionAsNumber = this.os.version ? parseFloat(this.os.version.match(/\d+(\.\d+)?/)[0]) : 0;
    }
    catch (e) {
        this.os.versionAsNumber = 0;
    }
};
export var tbBrowser = new TBBrowser();
